export const user = {
    firstName: '',
    lastName: '',
    email: '',
    oldEmail: '',
    primaryPhone: '',
    photoURL: '',
    account: '',
    client: '',
    site: '',
    siteGroup: '',
    clientGroup: '',
    companyUser: {
        status: 'ACTIVE',
        subtype: '',
    },
    address: {
        cep: '',
        address: '',
        number: '',
        complement: '',
        neighborhood: '',
        city: '',
        state: '',
        ibge: '',
        gia: '',
    },
    type: 'USER-COMPANY',
    status: 'ACTIVE',
}
